import { HttpClient } from '@angular/common/http';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { ServiceUtils } from '../service-utils/service-utils';
import { Observable, Subject } from 'rxjs';
import { AccessCodeLoginContext } from '@raptor-fe/core';

@Injectable({ providedIn: 'root' })
export class AccessCodeService implements OnDestroy {
    private lockSubject = new Subject<void>();

    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);

    ngOnDestroy(): void {
        this.completeLockSubject();
    }

    public sendAccessCode(accessCodeId: string): Observable<object> {
        return this.http.post(`${this.serviceUtils.getBaseUrl('accessCodeInfo')}/${accessCodeId}`, {});
    }

    /**
     * What the anonymous login page needs to render itself: which credential to ask for, and the
     * branding of the tenant the access code belongs to.
     *
     * The customer has not authenticated yet, so the access code id is the only thing that can name
     * a tenant. An unknown id answers the same as a tenant that has configured nothing, so the page
     * renders either way and the response cannot be used to test whether a link exists.
     */
    public getLoginContext(accessCodeId: string): Observable<AccessCodeLoginContext> {
        return this.http.get<AccessCodeLoginContext>(
            `${this.serviceUtils.getBaseUrl('accessCodeInfo')}/${accessCodeId}/branding`,
        );
    }

    private completeLockSubject(): void {
        this.lockSubject.next();
        this.lockSubject.complete();
    }
}
